document.addEventListener("DOMContentLoaded", () => {
    const cookieConsent = document.getElementById("cookieConsent");
    const acceptButton = document.getElementById("acceptCookies");
    const root = document.documentElement;

    if (!cookieConsent || !acceptButton) {
        return;
    }

    const setCookie = (name, value, days) => {
        const expiresAt = new Date(Date.now() + days * 24 * 60 * 60 * 1000);
        const secure = window.location.protocol === "https:" ? "; Secure" : "";

        document.cookie = `${encodeURIComponent(name)}=${encodeURIComponent(value)}; expires=${expiresAt.toUTCString()}; path=/; SameSite=Lax${secure}`;
    };

    const getCookie = name => {
        const encodedName = `${encodeURIComponent(name)}=`;
        const cookie = document.cookie
            .split(";")
            .map(value => value.trim())
            .find(value => value.startsWith(encodedName));

        return cookie ? decodeURIComponent(cookie.slice(encodedName.length)) : null;
    };

    const updatePromoOffset = () => {
        const height = cookieConsent.classList.contains("display") ? cookieConsent.offsetHeight : 0;

        root.style.setProperty("--cookie-consent-height", `${height}px`);
        window.dispatchEvent(new CustomEvent("cookieconsent:resize"));
    };

    if ("ResizeObserver" in window) {
        const resizeObserver = new ResizeObserver(updatePromoOffset);

        resizeObserver.observe(cookieConsent);
    } else {
        window.addEventListener("resize", updatePromoOffset);
    }

    if (getCookie("cookieConsent") !== "accepted") {
        window.setTimeout(() => {
            cookieConsent.classList.add("display");
            updatePromoOffset();
        }, 1000);
    }

    acceptButton.addEventListener("click", event => {
        event.preventDefault();
        setCookie("cookieConsent", "accepted", 365);
        cookieConsent.classList.remove("display");
        updatePromoOffset();
    });
});
